import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72579bd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "a-color-picker-container" }

import * as GameTypes from 'types/game.types';
import { ref } from 'vue';
import { randomUnique } from 'util/util';
import GridColorPicker from './grid-color-picker.vue';
import StackedCircleColorPicker from './stacked-circle-color-picker.vue';
import SingleColorPicker from './single-color-picker.vue';
import ScrollingColorPicker from './scrolling-color-picker.vue';
import RadialColorPicker from './radial-color-picker.vue';
import { Color } from 'chroma-js';
import { useModule } from 'src/modules/modules';


export default /*#__PURE__*/_defineComponent({
  __name: 'color-picker',
  props: {
    colors: null
  },
  emits: ['enter'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
    colors: Color[]
}

const { game } = useModule();




const getPickerComp = () => {
    //return ScrollingColorPicker;

    /**
     * If there is only one color, always use the single color picker.
     */
    if (props.colors.length === 1) return SingleColorPicker;
    /**
     * Otherwise get a random picker from a list of pickers that are appropriate for the number of colors.
     */
    const pickerComps : any[] = [GridColorPicker];
    if (props.colors.length <= 4) pickerComps.push(StackedCircleColorPicker);
    if (props.colors.length <= 20 && game.matchState.difficulty >= 1) pickerComps.push(RadialColorPicker);
    //if (props.colors.length >= 10 && game.matchState.difficulty > 0) pickerComps.push(ScrollingColorPicker);

    return randomUnique<any>(pickerComps, null);
}

const comp = getPickerComp();

const handleEnter = () => {
    let compName : GameTypes.PickerComponentName | null = null;
    switch (true){
        case comp === GridColorPicker:
            compName = 'GridColorPicker';
            break;
        case comp === StackedCircleColorPicker:
            compName = 'StackedCircleColorPicker';
            break;
        case comp === SingleColorPicker:
            compName = 'SingleColorPicker';
            break;
        case comp === ScrollingColorPicker:
            compName = 'ScrollingColorPicker';
            break;
        case comp === RadialColorPicker:
            compName = 'RadialColorPicker';
            break;
    }

    emit('enter', compName);
}

const picker = ref();
expose({
    leave: () : Promise<void> => picker.value?.leave()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(comp)), _mergeProps({
      ref_key: "picker",
      ref: picker
    }, _ctx.$attrs, {
      onEnter: handleEnter,
      colors: __props.colors
    }), null, 16, ["colors"]))
  ]))
}
}

})